import { Component, ChangeDetectionStrategy } from '@angular/core';
import { PagedObjectManagerComponent } from '../../../core/component/paged-object-manager/paged-object-manager';
import { FilterDefinitionItem } from '../../../core/model/filter-definition-item';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { feeChangeCommand } from '../../command/fee-change.command';
import { ChangeType, FeeChange } from '../../model/fee-change';
import { FeeChangeCommandHandlerResolver } from '../../service/command/fee-change-command-handler-resolver.service';
import { FeeChangeService } from '../../service/data/fee-change.service';
import { ColumnVisibility } from '../../../core/model/column-definition';

@Component({
    selector: 'app-debt-collection-manager',
    templateUrl: './fee-change-manager.component.html',
    styleUrls: ['./../../../core/component/paged-object-manager/paged-object-manager.scss'],
    providers: [FeeChangeCommandHandlerResolver, FeeChangeService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FeeChangeManagerComponent extends PagedObjectManagerComponent<FeeChange> {
  constructor(
    private _dataService: FeeChangeService,
    messageService: MessageService,
    navigation: NavigationService,
    cdf: ColumnDefinitionFactory,
    dispatcher: CommandDispatcher,
    handlerResolver: FeeChangeCommandHandlerResolver
  ) {
    super(_dataService, messageService, navigation, dispatcher, handlerResolver);

    this.columnDefinition = [
      cdf.create('FEE_CHANGE.CAPTION', 'caption'),
      cdf.createDateTime('FEE_CHANGE.PERFORMED_AT', 'performedAt'),
      cdf.createDate('FEE_CHANGE.CHANGE_FROM', 'changeFrom'),
      cdf.create('FEE_CHANGE.CHANGE_TYPE', 'changeType'),
      cdf.createNumber('FEE_CHANGE.CHANGE_VALUE', 'changeValue'),
      cdf.createBoolean('FEE_CHANGE.IS_RETROACTIVE', 'retroactive'),
      cdf.createDate('FEE_CHANGE.RETROACTIVE_FROM', 'retroactiveFrom'),
      cdf.createDate('FEE_CHANGE.RETROACTIVE_TO', 'retroactiveTo'),
      cdf.createBoolean('FEE_CHANGE.REVERTED', 'reverted', ColumnVisibility.optional),
      cdf.create('LOG.USERNAME', 'webUserName', ColumnVisibility.optional),
    ];

    this.title = 'DASHBOARD.MENU.FEE_CHANGE';

    this.addContextMenuItemDefinition('FEE_CHANGE.REVERT', feeChangeCommand.revert);
    this.preferencesKey = 'rent.fee-change-manager.list';
  }

  ngOnInit() {
    this.AddSubscription(
      this._dataService.getFilterDefinition().subscribe({
        next: filter => {
          const changeTypes = [
            { caption: 'ALL_TEXT', value: null },
            { caption: 'FEE_CHANGE.CHANGE_TYPES.FEE_CHANGE', value: ChangeType.Adjustment },
            { caption: 'FEE_CHANGE.CHANGE_TYPES.IMPORT', value: ChangeType.Import },
            { caption: 'FEE_CHANGE.CHANGE_TYPES.INDEX', value: ChangeType.Index },
            { caption: 'FEE_CHANGE.CHANGE_TYPES.FEE_CHANGE_PROPERTY_TAX', value: ChangeType.PropertyTaxAdjustment },
          ];
          const allYesNo = [
            { caption: 'ALL_TEXT', value: null },
            { caption: 'NO_TEXT', value: false },
            { caption: 'YES_TEXT', value: true },
          ];
          this.filterDefinition = [
            new FilterDefinitionItem('FEE_CHANGE.CAPTION', 'caption', filter.caption, null, filter.selectedFields.includes('caption')),
            new FilterDefinitionItem(
              'FEE_CHANGE.CHANGE_TYPE',
              'changeType',
              filter.changeType,
              changeTypes,
              filter.selectedFields.includes('changeType')
            ),
            new FilterDefinitionItem(
              'FEE_CHANGE.IS_RETROACTIVE',
              'retroactive',
              filter.retroactive,
              allYesNo,
              filter.selectedFields.includes('retroactive')
            ),
            new FilterDefinitionItem(
              'FEE_CHANGE.REVERTED',
              'reverted',
              filter.reverted,
              allYesNo,
              filter.selectedFields.includes('reverted')
            ),
          ];
        },
        error: error => {
          this.messageService.showError(error);
        },
      })
    );
  }
}
